import { getBrowserWidthBucket, getScreenOrientation } from 'owa-layout';
import type BrowserWidthBucket from 'owa-layout/lib/store/schema/BrowserWidthBucket';
import { isRPHiddenOrBottomByDefault } from './readingPanePosition';

/**
 * Returns a flag indicating whether to show folder pane as an overlay or not
 */
export function shouldShowFolderPaneAsOverlay(): boolean {
    const browserWidthBucket = getBrowserWidthBucket();
    const isRPHiddenORBottom = isRPHiddenOrBottomByDefault();
    const isPortraitMode = getScreenOrientation().startsWith('portrait');

    /*
     * In portrait mode, we want to show the folder pane as an overlay
     * This is because there is limited horizontal space in portrait mode
     * and we want to maximize the space for reading pane and message list
     * which are the primary areas of interaction for the user.
     */
    if (isPortraitMode) {
        return browserWidthBucket <= 999;
    }

    /**
     * When reading pane is hidden, we want to collapse the left nav as late as possible
     * as there are only two columns to share the space. This is so as to continue offering
     * the default layout of the user as much as we can.
     */
    if (isRPHiddenORBottom) {
        return browserWidthBucket <= 541;
    }

    /**
     * When reading pane is not hidden, there are three columns which share the space (LeftNav, ListView, RP)
     * In this case we are more aggressive on collapsing the left nav and showing it as overlay.
     */
    return browserWidthBucket <= 918;
}
